<template>
  <div class="InventoryShrimpInfo pt7" v-title data-title="库虾首页">
    <div class="row align-items-center justify-content-around stock-btn">
      <van-button v-for="st in stockBtns" :key="st.name" type="info" @click="go(st.path)">{{st.name}}</van-button>
    </div>
    <div><van-button type="info" plain @click="back" style="width: 60%;">返 回</van-button></div>
  </div>
</template>

<script>
import Vue from 'vue';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'InventoryShrimpInfo',
  components: {},
  data() {
    return {
      stockBtns: [
        { name: '库虾公司', path: '/stock/company/list' },
        { name: '库虾行话', path: '/stock/category/list' },
        { name: '库虾价格', path: '/stock/info/edit' },
      ],
    };
  },
  methods: {
    go(path) {
      if (!path) {
        return;
      }
      this.$router.push(path);
    },
    back() {
      this.$router.push('/home');
    },
  },
  created() {
    const type = storage.local.get('type');
    if (type === 1) {
      return;
    }
    this.$router.push('/stock/info/edit');
  },
});
</script>
<style scoped>
.InventoryShrimpInfo {
  min-height: 100vh;
}
.stock-btn {
  height: 60vh;
}
</style>
